/* eslint-disable react/prop-types */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { toast } from 'react-toastify';
import './EmployeeEffortEDR.scss';
import { Skeleton } from 'primereact/skeleton';
import { Tooltip } from 'primereact/tooltip';
import { TableUtility } from '@utility/dynamic-table';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import EdrEffortInitial from './EdrEffortInitial';
import { useAuth } from '../../../Hooks/useAuth';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../../../Api/resources/serviceURLs';
import { serviceName } from '../../../Api/resources/serviceConstants';
import {
  EDR_EMPLOYEE_EFFORTS,
  EDR_EMPLOYEE_EFFORTS_SUMMARY,
} from '../../../Api/resources/endPoint';
import exportToExcel from '../../../Utils/exportToExcel';

const getSummaryApiUrl = () => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${EDR_EMPLOYEE_EFFORTS_SUMMARY}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}/api${EDR_EMPLOYEE_EFFORTS_SUMMARY}`;
};

const getDetailedApiUrl = () => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${EDR_EMPLOYEE_EFFORTS}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}/api${EDR_EMPLOYEE_EFFORTS}`;
};

const TABLES_CONFIG = [
  {
    apiUrl: getSummaryApiUrl(),
    toolBarHeading: 'Summary',
  },
  {
    apiUrl: getDetailedApiUrl(),
    toolBarHeading: 'Employee Efforts',
  },
];

const isTotalRow = (row = {}) => row.isTotalRow
  || row.empId === 'Total'
  || row.vertical === 'Total Employee';

const summaryTotalFields = [
  'totalEmployees',
  'exemption',
  'zeroPercent',
  'oneToFifty',
  'fiftyOneToEighty',
  'eightyOneToNinety',
  'ninetyOneToHundred',
  'hundredOneToOneTwenty',
  'aboveOneTwenty',
];

const employeeEffortPhpExportColumns = [
  { header: 'Employee Id', field: 'Employee Id', width: 15 },
  { header: 'Employee Vertical', field: 'Employee Vertical', width: 25 },
  { header: 'Employee Type', field: 'Employee Type', width: 20 },
  { header: 'Employee Name', field: 'Employee Name', width: 30 },
  { header: 'Employee Designation', field: 'Employee Designation', width: 25 },
  { header: 'Employee Email ID', field: 'Employee Email ID', width: 30 },
  { header: 'Employee Status', field: 'Employee Status', width: 15 },
  { header: 'Leave (days)', field: 'Leave (days)', width: 15, numeric: true },
  { header: 'Logged Efforts %', field: 'Logged Efforts %', width: 18, numeric: true },
  { header: 'Expected Efforts (p.h.)', field: 'Expected Efforts (p.h.)', width: 22, numeric: true },
  { header: 'Logged Efforts (p.h.)', field: 'Logged Efforts (p.h.)', width: 22, numeric: true },
  { header: 'Unlogged Efgorts (p.h.)', field: 'Unlogged Efgorts (p.h.)', width: 22, numeric: true },
  { header: 'Total Excess Logged Effort (p.h.)', field: 'Total Excess Logged Effort (p.h.)', width: 25, numeric: true },
  { header: 'Weekend/ Holiday Effort (p.h.)', field: 'Weekend/ Holiday Effort (p.h.)', width: 28, numeric: true },
  { header: 'Weekend/ Holiday Effort (%)', field: 'Weekend/ Holiday Effort (%)', width: 28, numeric: true },
];

const employeeEffortPhpExcelColumns = employeeEffortPhpExportColumns.map((column) => ({
  ...column,
  key: column.field,
}));

const detailFieldAliases = {
  'Employee ID': 'empId',
  'Employee Id': 'empId',
  emp_id: 'empId',
  employeeId: 'empId',
  'Employee Type': 'employeeType',
  emp_type: 'employeeType',
  'Employee Designation': 'designation',
  'Employee Email ID': 'emailId',
  email_id: 'emailId',
  'Employee Status': 'employeeStatus',
  employee_status: 'employeeStatus',
  'Leave': 'totLeave',
  'Leave (Days)': 'totLeave',
  'Leave (days)': 'totLeave',
  tot_leave: 'totLeave',
  'Logged Effort %': 'loggedEffortsPercentage',
  'Logged Efforts %': 'loggedEffortsPercentage',
  logged_efforts_percentage: 'loggedEffortsPercentage',
  'Expected Efforts': 'expectedEfforts',
  'Expected Efforts (p.h.)': 'expectedEfforts',
  expected_efforts: 'expectedEfforts',
  'Logged Efforts': 'totEffort',
  'Logged Efforts (p.h.)': 'totEffort',
  tot_effort: 'totEffort',
  'Unlogged Efforts': 'unloggedEfforts',
  'Unlogged Efforts (p.h.)': 'unloggedEfforts',
  'Unlogged Efgorts (p.h.)': 'unloggedEfforts',
  unlogged_efforts: 'unloggedEfforts',
  'Total Excess Logged Effort': 'excessEfforts',
  'Total Excess Logged Effort (p.h.)': 'excessEfforts',
  excess_efforts: 'excessEfforts',
  'Weekend/Holiday Effort': 'weekendEfforts',
  'Weekend/ Holiday Effort (p.h.)': 'weekendEfforts',
  weekend_efforts: 'weekendEfforts',
  'Weekend/Holiday Effort %': 'weekendEffortsPercentage',
  'Weekend/ Holiday Effort (%)': 'weekendEffortsPercentage',
  weekend_efforts_percentage: 'weekendEffortsPercentage',
};

const normalizeDetailField = (field) => detailFieldAliases[field] || field;

const detailOnlyFilterFields = new Set([
  'empId',
  'employeeType',
  'designation',
  'emailId',
  'employeeStatus',
  'totLeave',
  'loggedEffortsPercentage',
  'expectedEfforts',
  'totEffort',
  'unloggedEfforts',
  'excessEfforts',
  'weekendEfforts',
  'weekendEffortsPercentage',
]);

const detailHeaderFields = new Set(detailOnlyFilterFields);
const globalSortableFields = new Set(['vertical', 'empName']);
const hiddenEmployeeEffortTableFields = new Set([
  'employeeType',
  'designation',
  'employeeStatus',
  'emailId',
]);

const headerFieldAliases = {
  'Employee Name': 'empName',
  'Employee Vertical': 'vertical',
  ...detailFieldAliases,
};

const normalizeHeaderField = (field) => headerFieldAliases[field] || normalizeDetailField(field);

const hideEmployeeEffortTableColumns = (columns = []) => (
  (columns || []).map((column) => (
    hiddenEmployeeEffortTableFields.has(normalizeHeaderField(column.field || column.header))
      ? { ...column, visible: false }
      : column
  ))
);

const summaryExportColumns = [
  { header: 'Employee Vertical', field: 'Employee Vertical', key: 'Employee Vertical', width: 25 },
  { header: 'Total Employees', field: 'Total Employees', key: 'Total Employees', width: 18, numeric: true },
  { header: 'Exemption', field: 'Exemption', key: 'Exemption', width: 15, numeric: true },
  { header: '0%', field: '0%', key: '0%', width: 12, numeric: true },
  { header: '1% - 50%', field: '1% - 50%', key: '1% - 50%', width: 15, numeric: true },
  { header: '51% - 80%', field: '51% - 80%', key: '51% - 80%', width: 15, numeric: true },
  { header: '81% - 90%', field: '81% - 90%', key: '81% - 90%', width: 15, numeric: true },
  { header: '91% - 100%', field: '91% - 100%', key: '91% - 100%', width: 15, numeric: true },
  { header: '101% - 120%', field: '101% - 120%', key: '101% - 120%', width: 15, numeric: true },
  { header: '121% +', field: '121% +', key: '121% +', width: 12, numeric: true },
];

const transformSummaryExport = (rows = []) => (
  recalculateSummaryTotalRow(rows)
    .filter((row = {}) => row.id?.toString?.().startsWith('pad-') !== true)
    .map((row = {}) => ({
      'Employee Vertical': firstValue(row, ['Employee Vertical', 'vertical']),
      'Total Employees': firstValue(row, ['Total Employees', 'totalEmployees']),
      'Exemption': firstValue(row, ['Exemption', 'exemption']),
      '0%': firstValue(row, ['0%', 'zeroPercent']),
      '1% - 50%': firstValue(row, ['1% - 50%', 'oneToFifty']),
      '51% - 80%': firstValue(row, ['51% - 80%', 'fiftyOneToEighty']),
      '81% - 90%': firstValue(row, ['81% - 90%', 'eightyOneToNinety']),
      '91% - 100%': firstValue(row, ['91% - 100%', 'ninetyOneToHundred']),
      '101% - 120%': firstValue(row, ['101% - 120%', 'hundredOneToOneTwenty']),
      '121% +': firstValue(row, ['121% +', 'aboveOneTwenty']),
    }))
    .filter((row) => Object.values(row).some((value) => value !== ''))
);

const getNestedValue = (row = {}, path = '') => (
  Object.prototype.hasOwnProperty.call(row, path)
    ? row[path]
    : String(path)
      .split('.')
      .reduce((acc, key) => (
        acc && acc[key] !== undefined ? acc[key] : undefined
      ), row)
);

const firstValue = (row = {}, paths = []) => {
  for (const path of paths) {
    const value = getNestedValue(row, path);
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return '';
};

const transformEmployeeEffortsExport = (response) => {
  const body = response?.data || response || {};
  const payload = body.data || body || {};
  const rawRows = Array.isArray(payload.tableData)
    ? payload.tableData
    : Array.isArray(payload)
      ? payload
      : [];

  const tableData = rawRows
    .filter((row = {}) => row.id?.toString?.().startsWith('pad-') !== true)
    .map((row = {}) => ({
      'Employee Id': firstValue(row, ['Employee Id', 'empId']),
      'Employee Vertical': firstValue(row, ['Employee Vertical', 'vertical']),
      'Employee Type': firstValue(row, ['Employee Type', 'employeeType', 'emp_type']),
      'Employee Name': firstValue(row, ['Employee Name', 'empName.empName', 'empName', 'emp_name']),
      'Employee Designation': firstValue(row, ['Employee Designation', 'designation']),
      'Employee Email ID': firstValue(row, ['Employee Email ID', 'emailId', 'email_id']),
      'Employee Status': firstValue(row, ['Employee Status', 'employeeStatus', 'employee_status']),
      'Leave (days)': firstValue(row, ['Leave (days)', 'totLeave', 'tot_leave']),
      'Logged Efforts %': firstValue(row, ['Logged Efforts %', 'loggedEffortsPercentage', 'logged_efforts_percentage']),
      'Expected Efforts (p.h.)': firstValue(row, ['Expected Efforts (p.h.)', 'expectedEfforts', 'expected_efforts']),
      'Logged Efforts (p.h.)': firstValue(row, ['Logged Efforts (p.h.)', 'totEffort', 'tot_effort']),
      'Unlogged Efgorts (p.h.)': firstValue(row, ['Unlogged Efgorts (p.h.)', 'unloggedEfforts', 'unlogged_efforts']),
      'Total Excess Logged Effort (p.h.)': firstValue(
        row,
        ['Total Excess Logged Effort (p.h.)', 'excessEfforts', 'excess_efforts'],
      ),
      'Weekend/ Holiday Effort (p.h.)': firstValue(
        row,
        ['Weekend/ Holiday Effort (p.h.)', 'weekendEfforts', 'weekend_efforts'],
      ),
      'Weekend/ Holiday Effort (%)': firstValue(
        row,
        ['Weekend/ Holiday Effort (%)', 'weekendEffortsPercentage', 'weekend_efforts_percentage'],
      ),
    }))
    .filter((row) => Object.values(row).some((value) => value !== ''));

  return {
    tableConfiguration: employeeEffortPhpExportColumns,
    tableData,
  };
};

const getEmployeeEffortsExportName = (isSummary) => (
  isSummary ? 'Employee Effort Summary' : 'EDR Employee Effort'
);

const recalculateSummaryTotalRow = (rows = []) => {
  const summaryRows = rows.filter(row => !isTotalRow(row));
  const totalRows = rows.filter(isTotalRow);

  if (!totalRows.length) return rows;

  const recalculatedTotal = summaryRows.reduce((acc, row) => {
    summaryTotalFields.forEach((field) => {
      acc[field] += Number(row[field]) || 0;
    });
    return acc;
  }, summaryTotalFields.reduce((acc, field) => ({ ...acc, [field]: 0 }), {}));

  return [
    ...summaryRows,
    {
      ...totalRows[0],
      ...recalculatedTotal,
      vertical: 'Total Employee',
      isTotalRow: true,
    },
  ];
};

const forceServerSideSorting = (columns = []) => (
  (columns || []).map((column) => ({
    ...column,
    menuItems: (column.menuItems || []).map((menuGroup) => ({
      ...menuGroup,
      items: (menuGroup.items || []).map((item) => (
        item?.type === 'sort'
          ? {
            ...item,
            serverSideSorting: true,
            field: normalizeHeaderField(item.field || column.field || column.header),
          }
          : item
      )),
    })),
  }))
);

const LocalSkeleton = () => (
  <div className="skeleton-loader">
    {[1, 2].map((key) => (
      <div key={key} className="skeleton-card">
        <div className="skeleton-header">
          <Skeleton width="180px" height="1.5rem" />
          <div style={{ display: 'flex', gap: '8px' }}>
            <Skeleton width="80px" height="1.5rem" />
            <Skeleton width="80px" height="1.5rem" />
          </div>
        </div>
        <div style={{ padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Skeleton width="100%" height="2rem" />
          <Skeleton width="100%" height="2rem" />
          <Skeleton width="100%" height="2rem" />
          <Skeleton width="100%" height="2rem" />
          <Skeleton width="100%" height="2rem" />
        </div>
      </div>
    ))}
  </div>
);

const getFilterValue = (value) => {
  if (value && typeof value === 'object') {
    return value.value ?? value.id ?? value.name ?? value.label ?? value;
  }
  return value;
};

const normalizeFilterPayload = (filters = []) => (
  (filters || []).map((filter) => ({
    ...filter,
    field: normalizeDetailField(filter?.field),
    ...(Array.isArray(filter?.selectedValues)
      ? { selectedValues: filter.selectedValues.map(getFilterValue) }
      : {}),
    ...(filter?.selectedValue !== undefined
      ? { selectedValue: getFilterValue(filter.selectedValue) }
      : {}),
  }))
);

const mergeFilterPayload = (existingFilters = [], incomingFilters = []) => {
  const normalizedIncomingFilters = normalizeFilterPayload(incomingFilters);
  const incomingFields = new Set(
    normalizedIncomingFilters.map((filter) => filter?.field).filter(Boolean),
  );
  const merged = (existingFilters || []).filter(
    (filter) => !incomingFields.has(filter?.field) && filter?.type !== 'sort',
  );
  return [...merged, ...normalizedIncomingFilters.filter((filter) => filter?.type !== 'sort')];
};

const extractStateFilters = (apiTableState = {}) => {
  if (Array.isArray(apiTableState.filters)) return apiTableState.filters;
  if (Array.isArray(apiTableState.filter)) return apiTableState.filter;
  if (Array.isArray(apiTableState.appliedFilters)) return apiTableState.appliedFilters;
  if (!apiTableState.filterPayload || typeof apiTableState.filterPayload !== 'object') return [];

  return Object.entries(apiTableState.filterPayload).map(([field, value]) => ({
    field,
    ...(Array.isArray(value?.range) ? { range: value.range } : {}),
    ...(Array.isArray(value?.selectedValues) ? { selectedValues: value.selectedValues } : {}),
  }));
};

const getOverlayField = (target) => {
  const overlay = target?.closest?.(
    '.tu-column-menu-template, .tu-filter-template-panel, .tu-filter-panel, .tu-filter-floating',
  ) || document.querySelector(
    '.tu-column-menu-template, .tu-filter-template-panel, .tu-filter-panel, .tu-filter-floating',
  );

  const title = overlay?.querySelector?.(
    '.tu-filter-template-title, .tu-column-menu-template-title, .tu-multi-select-title, .tu-value-condition-title',
  )?.textContent?.trim();

  return normalizeHeaderField(title);
};

const getActiveGlobalFilterFieldFromDom = () => {
  const candidates = Array.from(document.querySelectorAll(
    '.tu-filter-column-item.active, .tu-filter-column-item.applied, '
    + '.tu-filter-detail-action.active, .tu-column-menu-item.active, '
    + '.p-menuitem-active > .p-menuitem-content .p-menuitem-text, '
    + '.p-menuitem-active > .p-menuitem-link .p-menuitem-text',
  ));

  for (const candidate of candidates) {
    const normalizedField = normalizeHeaderField(
      candidate?.textContent?.replace(/\*/g, '')?.trim(),
    );
    if (['dateRange', 'vertical', 'empName'].includes(normalizedField)) {
      return normalizedField;
    }
  }

  return null;
};

const getGlobalFilterFieldFromTarget = (target) => {
  const fieldElement = target?.closest?.(
    '.tu-filter-column-item, .tu-filter-detail-action, '
    + '.p-menuitem, .p-menuitem-link, [role="menuitem"], button',
  );
  const text = fieldElement?.textContent?.replace(/\*/g, '')?.trim();
  if (!text || /^sort\s/i.test(text)) return null;

  const matchedLabel = Object.keys(headerFieldAliases)
    .sort((first, second) => second.length - first.length)
    .find((label) => text.includes(label));
  const normalizedField = normalizeHeaderField(matchedLabel || text);

  return globalSortableFields.has(normalizedField) ? normalizedField : null;
};

const getHeaderSortFieldFromDom = (target, tableConfig = []) => {
  const headerCell = target?.closest?.('.custom-table-employee-efforts .p-datatable-thead th');
  if (!headerCell) return null;

  const attrField = headerCell.getAttribute('data-p-field')
    || headerCell.getAttribute('data-field')
    || headerCell.dataset?.field
    || headerCell.dataset?.pField;
  if (attrField) return normalizeHeaderField(attrField);

  const headerText = headerCell.querySelector('.tu-header-line')?.textContent?.trim()
    || headerCell.querySelector('.p-column-title')?.textContent?.trim()
    || headerCell.textContent?.replace(/\s+/g, ' ')?.trim();
  const normalizedHeader = normalizeHeaderField(headerText);
  if (normalizedHeader && normalizedHeader !== headerText) return normalizedHeader;

  const matchedHeader = Object.keys(headerFieldAliases)
    .sort((first, second) => second.length - first.length)
    .find((label) => headerText?.startsWith(label));
  if (matchedHeader) return normalizeHeaderField(matchedHeader);

  const headerIndex = Array.from(headerCell.parentElement?.children || []).indexOf(headerCell);
  const visibleColumns = (tableConfig || []).filter((column) => column?.visible !== false);
  const fieldFromIndex = visibleColumns[headerIndex]?.field;

  return normalizeHeaderField(fieldFromIndex || headerText);
};

const getNextHeaderSort = (field, currentSort = null) => {
  const normalizedField = normalizeHeaderField(field);
  if (!normalizedField) return null;

  const isSameField = currentSort?.field === normalizedField;
  const direction = isSameField && currentSort?.direction === 'ASC' ? 'DESC' : 'ASC';

  return {
    field: normalizedField,
    order: direction === 'ASC' ? 1 : -1,
    direction,
  };
};

const getHeaderIconSort = (target, field) => {
  const normalizedField = normalizeHeaderField(field);
  if (!normalizedField) return null;

  const isAscendingIcon = Boolean(target?.closest?.('.pi-angle-up, .pi-arrow-up'));
  const isDescendingIcon = Boolean(target?.closest?.('.pi-angle-down, .pi-arrow-down'));
  if (!isAscendingIcon && !isDescendingIcon) return null;

  const direction = isAscendingIcon ? 'ASC' : 'DESC';
  return {
    field: normalizedField,
    order: direction === 'ASC' ? 1 : -1,
    direction,
  };
};

const getSortFromDom = (target) => {
  const sortButton = target?.closest?.(
    '.tu-column-menu-action, .tu-outside-filter-sort-button, '
    + '.p-menuitem-link, .p-menuitem, button, [role="menuitem"]',
  );
  const text = sortButton?.textContent?.trim?.() || '';
  const hasDescendingIcon = Boolean(sortButton?.querySelector?.('.pi-arrow-down, .pi-angle-down'));
  const hasAscendingIcon = Boolean(sortButton?.querySelector?.('.pi-arrow-up, .pi-angle-up'));

  if (/desc|z-a/i.test(text) || hasDescendingIcon) {
    return { order: -1, direction: 'DESC' };
  }
  if (/asc|a-z/i.test(text) || hasAscendingIcon) {
    return { order: 1, direction: 'ASC' };
  }
  return null;
};

const getActiveDetailFilterFromDom = (target) => {
  const field = getOverlayField(target);
  if (!detailOnlyFilterFields.has(field)) return null;

  const filterElement = target?.closest?.(
    '.tu-multi-select-filter, .tu-single-select-filter, .tu-value-condition-filter',
  ) || target?.closest?.('.tu-column-menu-template, .tu-filter-template-panel');

  if (!filterElement) return { field };

  const checkedInputs = Array.from(filterElement.querySelectorAll('input[type="checkbox"]:checked'));
  const selectedValues = checkedInputs
    .map((input) => (
      input.closest('label')?.textContent
      || input.parentElement?.textContent
      || input.value
    ))
    .map((value) => String(value || '').trim())
    .filter(Boolean);

  if (selectedValues.length > 0) return { field, selectedValues };

  const rangeInputs = Array.from(filterElement.querySelectorAll('input'))
    .filter((input) => input.type !== 'checkbox')
    .map((input) => input.value)
    .filter((value) => value !== undefined);

  if (rangeInputs.length >= 2) {
    return { field, range: [rangeInputs[0] || null, rangeInputs[1] || null] };
  }

  return { field };
};

const mergeDomFilterFallback = (filters = [], domFilter = null) => {
  if (!domFilter?.field) return filters;
  if ((filters || []).some((filter) => normalizeDetailField(filter?.field) === domFilter.field)) {
    return filters;
  }
  if (!domFilter.selectedValues?.length && !domFilter.range?.some(Boolean)) return filters;
  return [...filters, domFilter];
};

const hasCompleteDateRangeFilter = (filters = []) => (
  (filters || []).some((value) => (
    value?.field === 'dateRange'
    && Array.isArray(value.range)
    && value.range.length === 2
    && value.range[0]
    && value.range[1]
  ))
);

const formatDateOnly = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const buildDefaultDateRangeFilter = () => {
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  return [{
    field: 'dateRange',
    range: [formatDateOnly(firstDayOfMonth), formatDateOnly(today)],
  }];
};

const hasSelectedValueFilter = (filter = {}) => (
  Array.isArray(filter.selectedValues) && filter.selectedValues.length > 0
);

const hasRangeValueFilter = (filter = {}) => (
  filter?.field !== 'dateRange'
  && Array.isArray(filter.range)
  && filter.range.some((value) => value !== null && value !== undefined && value !== '')
);

const clearFilterColumnState = (columns = []) => (
  (columns || []).map((column) => ({
    ...column,
    menuItems: (column.menuItems || []).map((menuGroup) => ({
      ...menuGroup,
      items: (menuGroup.items || []).map((item) => {
        if (item.type !== 'filter') return item;
        if (item.field === 'dateRange') {
          return {
            ...item,
            range: buildDefaultDateRangeFilter()[0].range,
          };
        }
        return {
          ...item,
          selectedValues: [],
          selectedValue: null,
          range: Array.isArray(item.range) ? [null, null] : item.range,
        };
      }),
    })),
  }))
);

const INITIAL_PAGINATIONS = {
  'Summary': { page: 1, limit: 100000, total: 0 },
  'Employee Efforts': { page: 1, limit: 100000, total: 0 },
};

const EDREmployeeEffortMain = () => {
  const { userProfile } = useAuth();
  const userProfileRef = useRef(userProfile);
  userProfileRef.current = userProfile;
  const [tables, setTables] = useState([
    { configuration: null, data: [], toolBarHeading: 'Employee Efforts' },
    { configuration: null, data: [], toolBarHeading: 'Summary' },
  ]);
  const tablesRef = useRef(tables);
  tablesRef.current = tables;
  const [loading, setLoading] = useState(true);
  const loadingRef = useRef(loading);
  loadingRef.current = loading;
  const [isTableRenderPending, setIsTableRenderPending] = useState(false);

  const [globalFilters, setGlobalFilters] = useState(buildDefaultDateRangeFilter);
  const [globalSort, setGlobalSort] = useState(null);
  const [globalFilterColumns, setGlobalFilterColumns] = useState([]);
  const [tableResetKey, setTableResetKey] = useState(0);

  const [paginations, setPaginations] = useState(INITIAL_PAGINATIONS);

  const tableStateRefs = useRef({});

  const globalFiltersRef = useRef(globalFilters);
  globalFiltersRef.current = globalFilters;
  const globalSortRef = useRef(globalSort);
  globalSortRef.current = globalSort;
  const paginationsRef = useRef(paginations);
  paginationsRef.current = paginations;
  const globalFilterStateRef = useRef(null);
  const activeGlobalFilterFieldRef = useRef(null);
  const exportInProgressRef = useRef(false);

  useEffect(() => {
    if (!isTableRenderPending) return undefined;

    const tableSelectors = tables
      .filter((table) => Array.isArray(table.data) && table.data.length > 0)
      .map((table) => `.custom-table-${table.toolBarHeading.replace(/\s+/g, '-').toLowerCase()}`);

    let animationFrameId = null;
    const hasRenderedRows = (selector) => (
      Array.from(document.querySelectorAll(`${selector} .p-datatable-tbody > tr`))
        .some((row) => {
          const rowText = row.textContent?.trim() || '';
          return row.querySelector('td') && rowText && rowText !== 'No records found';
        })
    );

    const releaseRenderPending = () => {
      setIsTableRenderPending(false);
    };

    const checkRenderedRows = () => {
      if (tableSelectors.length === 0 || tableSelectors.every(hasRenderedRows)) {
        releaseRenderPending();
        return;
      }

      animationFrameId = requestAnimationFrame(checkRenderedRows);
    };

    animationFrameId = requestAnimationFrame(checkRenderedRows);

    return () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
    };
  }, [isTableRenderPending, tables]);

  useEffect(() => {
    let animationFrameId = null;

    const moveTotalRowsToBottom = () => {
      document
        .querySelectorAll('.custom-table-employee-efforts .p-datatable-tbody')
        .forEach((tbody) => {
          Array.from(tbody.children).forEach((row) => {
            const firstCellText = row.querySelector('td')?.textContent?.trim();
            if (firstCellText === 'Total' && row.nextElementSibling) {
              tbody.appendChild(row);
            }
          });
        });

      document
        .querySelectorAll('.custom-table-employee-efforts .sort-icon-div')
        .forEach((sortIconContainer) => {
          const [ascendingIcon, descendingIcon] = Array.from(sortIconContainer.querySelectorAll('i'));
          ascendingIcon?.setAttribute('title', 'Sort Ascending');
          ascendingIcon?.setAttribute('aria-label', 'Sort Ascending');
          descendingIcon?.setAttribute('title', 'Sort Descending');
          descendingIcon?.setAttribute('aria-label', 'Sort Descending');
        });

    };

    const scheduleMove = () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      animationFrameId = requestAnimationFrame(moveTotalRowsToBottom);
    };

    scheduleMove();

    const observer = new MutationObserver(scheduleMove);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      observer.disconnect();
    };
  }, [tables]);

  const handleEmployeeEffortsExport = useCallback(async () => {
    if (exportInProgressRef.current) return;

    const currentUserProfile = userProfileRef.current;
    if (!currentUserProfile?.email) return;

    const filters = globalFiltersRef.current || [];
    if (!hasCompleteDateRangeFilter(filters)) {
      toast.error('Please select a date range before exporting.', {
        position: 'top-center',
      });
      return;
    }

    exportInProgressRef.current = true;
    try {
      const response = await fetch(`${getDetailedApiUrl()}/export`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'token': currentUserProfile?.access_token || localStorage.getItem('authToken') || '',
        },
        body: JSON.stringify({
          filter: normalizeFilterPayload(filters),
          userInfo: {
            emailId: currentUserProfile.email,
            permissions: currentUserProfile.permissions,
            roleDetails: currentUserProfile.roleDetails,
            employeeId: currentUserProfile.employeeId,
            globalColors: currentUserProfile?.siteConfiguration?.global_colors,
          },
        }),
      });
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || 'Failed to export Employee Efforts.');
      }

      const exportPayload = transformEmployeeEffortsExport(json);
      if (!exportPayload.tableData.length) {
        toast.error('No data available to export.', { position: 'top-center' });
        return;
      }

      await exportToExcel({
        data: exportPayload.tableData,
        workBookTitle: getEmployeeEffortsExportName(false),
        workSheetTitle: getEmployeeEffortsExportName(false),
        columnsConfig: employeeEffortPhpExcelColumns,
      });
    } catch (error) {
      toast.error(error.message || 'Failed to export Employee Efforts.', {
        position: 'top-center',
      });
    } finally {
      exportInProgressRef.current = false;
    }
  }, []);

  const handleSummaryExport = useCallback(async () => {
    if (exportInProgressRef.current) return;

    const currentUserProfile = userProfileRef.current;
    if (!currentUserProfile?.email) return;

    const filters = globalFiltersRef.current || [];
    if (!hasCompleteDateRangeFilter(filters)) {
      toast.error('Please select a date range before exporting.', {
        position: 'top-center',
      });
      return;
    }

    try {
      exportInProgressRef.current = true;
      const summaryTable = tablesRef.current.find((table) => table.toolBarHeading === 'Summary');
      const summaryRows = transformSummaryExport(summaryTable?.data || []);
      if (!summaryRows.length) {
        toast.error('No data available to export.', { position: 'top-center' });
        return;
      }

      await exportToExcel({
        data: summaryRows,
        workBookTitle: getEmployeeEffortsExportName(true),
        workSheetTitle: getEmployeeEffortsExportName(true),
        columnsConfig: summaryExportColumns,
      });
    } catch (error) {
      toast.error(error.message || 'Failed to export Summary.', {
        position: 'top-center',
      });
    } finally {
      exportInProgressRef.current = false;
    }
  }, []);

  useEffect(() => {
    const handleTableInteractions = (event) => {
      const target = event.target;
      if (!target?.closest) return;

      const downloadButton = target.closest('.custom-table-employee-efforts button');
      const isEmployeeEffortsDownload = Boolean(
        downloadButton
        && (
          downloadButton.querySelector('.pi-download, .pi-file-excel')
          || downloadButton.querySelector('svg')
        )
        && !target.closest('.p-datatable-thead')
        && !target.closest('.p-paginator'),
      );

      if (isEmployeeEffortsDownload) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation?.();
        handleEmployeeEffortsExport();
        return;
      }

      const summaryDownloadButton = target.closest('.custom-table-summary button');
      const isSummaryDownload = Boolean(
        summaryDownloadButton
        && (
          summaryDownloadButton.querySelector('.pi-download, .pi-file-excel')
          || summaryDownloadButton.querySelector('svg')
        )
        && !target.closest('.p-datatable-thead')
        && !target.closest('.p-paginator'),
      );

      if (isSummaryDownload) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation?.();
        handleSummaryExport();
        return;
      }

      const isResetButton = Boolean(target.closest('.pi-refresh')
      || target.closest('button[aria-label*="Reset"]'));
      const isFilterReset = Boolean(target.closest('.tu-filter-footer-reset')
      || target.closest('button[aria-label*="Clear"]'));

      if (isResetButton) {
        const defaultFilters = buildDefaultDateRangeFilter();
        setGlobalFilters(defaultFilters);
        setGlobalSort(null);
        setPaginations(INITIAL_PAGINATIONS);
        setGlobalFilterColumns((previousColumns) => clearFilterColumnState(previousColumns));
        setTableResetKey((previousKey) => previousKey + 1);
        handleGlobalFilterApply(defaultFilters, null, INITIAL_PAGINATIONS);
      }

      if (isFilterReset) {
        const defaultFilters = buildDefaultDateRangeFilter();
        setGlobalFilters(defaultFilters);
        setGlobalSort(null);
        activeGlobalFilterFieldRef.current = null;
        setPaginations(INITIAL_PAGINATIONS);
        setGlobalFilterColumns((previousColumns) => clearFilterColumnState(previousColumns));
        setTableResetKey((previousKey) => previousKey + 1);
        handleGlobalFilterApply(defaultFilters, null, INITIAL_PAGINATIONS);
      }

      const clickedGlobalFilterField = getGlobalFilterFieldFromTarget(target);
      if (clickedGlobalFilterField) {
        activeGlobalFilterFieldRef.current = clickedGlobalFilterField;
      }

      const isHeaderCellClick = Boolean(target.closest('.custom-table-employee-efforts .p-datatable-thead th'));
      const isHeaderControlClick = Boolean(target.closest(
        '.three-dot, .p-column-filter-menu-button, .p-column-filter, '
        + '.tu-column-menu-action, .tu-multi-select-apply, .tu-single-select-apply, '
        + '.tu-value-condition-apply, .tu-outside-filter-apply, .tu-filter-footer-apply',
      ));
      const isSortHeader = isHeaderCellClick && !isHeaderControlClick;
      const isColumnMenuAction = Boolean(target.closest('.tu-column-menu-action')
      || target.closest('.tu-outside-filter-sort-button'));
      const isColumnFilterApply = Boolean(target.closest('.tu-multi-select-apply')
      || target.closest('.tu-single-select-apply')
      || target.closest('.tu-value-condition-apply')
      || target.closest('.tu-outside-filter-apply')
      || target.closest('.tu-filter-footer-apply')
      || (
        target.closest('button')?.textContent?.trim() === 'Apply'
        && target.closest(
          '.tu-column-menu-template, .tu-filter-template-panel, .tu-filter-panel, .tu-filter-floating',
        )
      ));
      const domSort = getSortFromDom(target);

      if (isSortHeader || isColumnMenuAction || isColumnFilterApply || domSort) {
        if (isSortHeader) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation?.();
        }

        const isSummaryTable = Boolean(target.closest('.custom-table-summary'));
        const isDetailedTable = Boolean(target.closest('.custom-table-employee-efforts'));
        const isGlobalFilterOverlay = Boolean(target.closest(
          '.tu-filter-floating, .tu-filter-template-panel, .tu-filter-panel, '
          + '.p-tieredmenu, .p-menu, .p-overlaypanel',
        ));
        const currentDetailedConfig = tablesRef.current.find(
          (table) => table.toolBarHeading === 'Employee Efforts',
        )?.configuration?.tableSettings?.tableConfig || [];
        const headerSortField = isSortHeader
          ? getHeaderSortFieldFromDom(target, currentDetailedConfig)
          : null;
        const overlayField = normalizeHeaderField(
          headerSortField
          || getOverlayField(target)
          || getActiveGlobalFilterFieldFromDom(),
        );
        const isSortAction = Boolean(isSortHeader || domSort);
        if (loadingRef.current && !isSortAction) return;
        const isDetailedOverlayAction = Boolean(
          (isColumnMenuAction || isColumnFilterApply)
          && detailHeaderFields.has(overlayField),
        );
        const isGlobalFilterMenuSort = Boolean(
          !isSummaryTable
          && !isDetailedTable
          && domSort
          && (isGlobalFilterOverlay || activeGlobalFilterFieldRef.current),
        );

        let heading = null;
        if (isSummaryTable) heading = 'Summary';
        if (isDetailedTable) heading = 'Employee Efforts';
        if (!heading && isDetailedOverlayAction) heading = 'Employee Efforts';

        if (isGlobalFilterMenuSort) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation?.();

          const newSortField = normalizeHeaderField(
            activeGlobalFilterFieldRef.current
            || overlayField
            || getActiveGlobalFilterFieldFromDom(),
          );
          const newSortOrder = domSort?.order;
          if (!newSortField || !newSortOrder) return;

          const nextSort = {
            field: newSortField,
            order: newSortOrder,
            direction: domSort.direction || (newSortOrder === 1 ? 'ASC' : 'DESC'),
          };
          const updatedPaginations = paginationsRef.current;
          setPaginations(updatedPaginations);
          handleGlobalFilterApply(
            globalFiltersRef.current,
            nextSort,
            updatedPaginations,
          ).then((applied) => {
            if (applied) setGlobalSort(nextSort);
          });
          return;
        }

        if (heading) {
          const domFilter = isColumnFilterApply ? getActiveDetailFilterFromDom(target) : null;
          setTimeout(async () => {
            if (loadingRef.current && !isSortAction) return;

            const apiTableState = tableStateRefs.current[heading]?.() || {};
            const newPage = 1;
            const newLimit = paginationsRef.current[heading].limit;
            const newSortField = normalizeDetailField(apiTableState.sortField || overlayField);
            const newSortOrder = apiTableState.sortOrder ?? domSort?.order;
            if (isSortAction && !newSortField) return;
            const nextFilters = heading === 'Employee Efforts'
              ? mergeDomFilterFallback(
                mergeFilterPayload(globalFiltersRef.current, extractStateFilters(apiTableState)),
                domFilter,
              )
              : globalFiltersRef.current;

            let nextSort = globalSortRef.current;
            if (isSortHeader && newSortField) {
              nextSort = getHeaderIconSort(target, newSortField)
                || getNextHeaderSort(newSortField, globalSortRef.current);
            } else if (newSortField) {
              nextSort = {
                field: newSortField,
                order: newSortOrder,
                direction: domSort?.direction || (newSortOrder === 1 ? 'ASC' : 'DESC'),
              };
            }

            const newPaginationForTable
              = {
                page: isColumnFilterApply ? 1 : newPage,
                limit: newLimit,
                total: paginationsRef.current[heading].total,
              };
            const updatedPaginations = { ...paginationsRef.current, [heading]: newPaginationForTable };

            setPaginations(updatedPaginations);
            const applied = await handleGlobalFilterApply(nextFilters, nextSort, updatedPaginations);
            if (applied && newSortField) {
              setGlobalSort(nextSort);
            }
          }, 100);
        }
      }
    };

    document.addEventListener('click', handleTableInteractions, true);
    return () => document.removeEventListener('click', handleTableInteractions, true);
  }, [handleEmployeeEffortsExport, handleSummaryExport]);

  const handlePaginationChange = useCallback((heading, newPagination) => {
    setPaginations((prev) => {
      const currentPagination = prev[heading] || { page: 1, limit: 100000, total: 0 };
      const nextLimit = Number(newPagination?.limit || newPagination?.rows || currentPagination.limit || 100000);
      const nextPage = Number(
        newPagination?.page
        || (
          newPagination?.first !== undefined
            ? Math.floor(Number(newPagination.first || 0) / nextLimit) + 1
            : currentPagination.page
        ),
      );
      const updated = {
        ...prev,
        [heading]: {
          ...currentPagination,
          ...newPagination,
          page: nextPage,
          limit: nextLimit,
        },
      };
      handleGlobalFilterApply(globalFiltersRef.current, globalSortRef.current, updated);
      return updated;
    });
  }, []);

  useEffect(() => {
    if (userProfile?.email) {
      setLoading(true);
      const defaultFilters = buildDefaultDateRangeFilter();
      setGlobalFilters(defaultFilters);
      setGlobalSort(null);
      setPaginations(INITIAL_PAGINATIONS);
      handleGlobalFilterApply(defaultFilters, null, INITIAL_PAGINATIONS);
    }
    // eslint-disable-next-line
  }, [!!userProfile?.email]);

  const handleGlobalFilterApply = async (
    appliedFilters,
    currentSort = globalSortRef.current,
    currentPaginations = paginationsRef.current,
  ) => {
    const currentUserProfile = userProfileRef.current;
    const nextFilters = normalizeFilterPayload(appliedFilters || []);

    const hasDateRange = hasCompleteDateRangeFilter(nextFilters);
    const hasValueFilters = nextFilters.some(hasSelectedValueFilter);
    const hasRangeFilters = nextFilters.some(hasRangeValueFilter);
    const isFilteringOrSorting = hasValueFilters || hasRangeFilters || Boolean(currentSort);
    if (isFilteringOrSorting && !hasDateRange) {
      toast.error('Please select a date range before applying other filters.', {
        position: 'top-center',
        style: {
          backgroundColor: '#bc4545',
          color: '#FFFFFF',
          borderRadius: '12px',
          fontFamily: 'Mukta',
        },
      });
      setTableResetKey((previousKey) => previousKey + 1);
      return false;
    }

    setGlobalFilters(nextFilters);
    setLoading(true);
    setIsTableRenderPending(false);

    const filterPayloadArray = [...nextFilters];
    if (currentSort) {
      const sortIndex = filterPayloadArray.findIndex(value => value.type === 'sort');
      if (sortIndex > -1) filterPayloadArray.splice(sortIndex, 1);
      filterPayloadArray.push({
        type: 'sort',
        field: currentSort.field,
        sortDirection: currentSort.direction,
        sortOrder: currentSort.order,
      });
    }

    try {
      const updatedTotals = { ...currentPaginations };
      let nextGlobalFilterColumns = [];

      const results = [];
      for (const tbl of TABLES_CONFIG) {
        const tablePagination = currentPaginations[tbl.toolBarHeading];

        const filterPayload = {
          filter: filterPayloadArray,
          ...(currentSort
            ? {
              sort: {
                field: currentSort.field,
                order: currentSort.direction || (currentSort.order === 1 ? 'ASC' : 'DESC'),
              },
              sortField: currentSort.field,
              sortOrder: currentSort.direction || (currentSort.order === 1 ? 'ASC' : 'DESC'),
            }
            : {}),
          pagination: {
            page: 1,
            limit: tablePagination.limit,
            dataLimit: tablePagination.limit,
            offset: 0,
          },
          userInfo: {
            emailId: currentUserProfile.email,
            permissions: currentUserProfile.permissions,
            roleDetails: currentUserProfile.roleDetails,
            employeeId: currentUserProfile.employeeId,
            globalColors: currentUserProfile?.siteConfiguration?.global_colors,
          },
        };

        const res = await fetch(tbl.apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token': currentUserProfile?.access_token || localStorage.getItem('authToken') || '',
          },
          body: JSON.stringify(filterPayload),
        });
        const json = await res.json();
        if (!res.ok) {
          throw new Error(json?.message || 'Failed to load data. Please try again.');
        }

        const tableData = json?.data?.tableData || [];

        const apiTotal = json?.meta?.total || json?.data?.paginationConfig?.total || 0;
        const apiPage = json?.meta?.page || tablePagination.page;
        const apiLimit = json?.meta?.pageSize || tablePagination.limit;

        updatedTotals[tbl.toolBarHeading] = {
          ...updatedTotals[tbl.toolBarHeading],
          total: apiTotal,
        };

        // --- TOOLTIP & FILTER PRESERVATION LOGIC ---
        let apiTableConfig = json?.data?.tableConfiguration || [];
        apiTableConfig = apiTableConfig.map((col) => {
          let updatedCol = { ...col };

          // 1. Inject the Tooltip
          if (updatedCol.field === 'exemption') {
            updatedCol = {
              ...updatedCol,
              header: (
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <span>Exemption</span>
                  <Tooltip
                    target=".exemption-icon-tooltip"
                    content="Leave for whole month like maternity leave"
                    position="top"
                  />
                  <i
                    className="pi pi-info-circle exemption-icon-tooltip"
                    style={{ color: '#289FF1', fontSize: '0.85rem', cursor: 'pointer' }}
                  ></i>
                </div>
              ),
              exportHeader: 'Exemption',
            };
          }

          const appliedFilter
              = filterPayloadArray.find(value => value.field === updatedCol.field && value.type !== 'sort');

          if (appliedFilter && updatedCol.menuItems?.length > 0) {
            updatedCol.menuItems = updatedCol.menuItems.map(menuGroup => ({
              ...menuGroup,
              items: (menuGroup.items || []).map(item => {
                if (item.type === 'filter') {
                  if (item.template === 'dateRange' && appliedFilter.range) {
                    return { ...item, range: appliedFilter.range };
                  }
                  if (item.template === 'multiSelect' && appliedFilter.selectedValues) {
                    return { ...item, selectedValues: appliedFilter.selectedValues };
                  }
                  if (item.template === 'range' && appliedFilter.range) {
                    return { ...item, range: appliedFilter.range };
                  }
                }
                return item;
              }),
            }));
          }
          return updatedCol;
        });

        if (tbl.toolBarHeading === 'Employee Efforts') {
          apiTableConfig = forceServerSideSorting(apiTableConfig);
          nextGlobalFilterColumns = apiTableConfig.filter((col) => col.isGlobalFilter);
          apiTableConfig = hideEmployeeEffortTableColumns(apiTableConfig);
        }
        // ---------------------------------

        const Summary = tbl.toolBarHeading === 'Summary';
        const renderTableData = Summary ? recalculateSummaryTotalRow(tableData) : tableData;

        const tableRows = (() => {
          const rows = renderTableData.filter(row => !isTotalRow(row));
          const totalRows = renderTableData.filter(isTotalRow);
          return totalRows.length > 0
            ? [...rows, ...totalRows]
            : rows;
        })();
        const tableClassName = `custom-table-${tbl.toolBarHeading.replace(/\s+/g, '-').toLowerCase()}`;
        const tableRenderKey = Summary
          ? tbl.toolBarHeading
          : [
            tbl.toolBarHeading,
            apiPage,
            apiLimit,
            apiTotal,
            JSON.stringify(currentSort || {}),
            JSON.stringify(nextFilters || []),
          ].join('|');

        const tableResult = {
          key: tableRenderKey,
          configuration: {
            generalSettings: {
              enableApiFiltering: false,
              baseURL: tbl.apiUrl,
              apiEndpoints: {
                getAllViews: { endpoint: '', enabled: false },
                getFilteredData: { endpoint: '', enabled: false },
                saveOrUpdateView: { endpoint: '', enabled: false },
                deleteView: { endpoint: '', enabled: false },
                download: {
                  endpoint: '/export',
                  enabled: true,
                  filename: () => getEmployeeEffortsExportName(Summary),
                  sheetName: () => getEmployeeEffortsExportName(Summary),
                  transformResponse: Summary
                    ? undefined
                    : (payload) => transformEmployeeEffortsExport(payload || renderTableData),
                },
              },
              enableFilters: !Summary,
              enableColumnFilterIcon: !Summary,
              showToolBar: true,
              toolBarSettings: {
                showToolBarHeading: true,
                toolBarHeading: tbl.toolBarHeading,
                showDownloadExcel: true,
                showDownloadCsv: false,
                downloadExcelFileName: () => getEmployeeEffortsExportName(Summary),
                downloadExcelSheetName: () => getEmployeeEffortsExportName(Summary),
                showColumnFilterMenu: !Summary,
                showFilterOption: false,
              },
              userInfo: {
                emailId: currentUserProfile.email,
                permissions: currentUserProfile.permissions,
                roleDetails: currentUserProfile.roleDetails,
                employeeId: currentUserProfile.employeeId,
                globalColors: currentUserProfile?.siteConfiguration?.global_colors,
              },
              headers: {
                token: currentUserProfile?.access_token || localStorage.getItem('authToken') || '',
              },
              handler: {
                setTableStateHandler: (getState) => {
                  tableStateRefs.current[tbl.toolBarHeading] = getState;
                },
                onFilterUpdate: ({ action, filters }) => {
                  if (tbl.toolBarHeading !== 'Employee Efforts') return;
                  if (action === 'reset') {
                    const mergedFilters = Array.isArray(filters)
                      ? mergeFilterPayload(globalFiltersRef.current, filters)
                      : globalFiltersRef.current;
                    handleGlobalFilterApply(mergedFilters, globalSortRef.current, paginationsRef.current);
                    return;
                  }
                  if (action !== 'apply') return;

                  const mergedFilters = mergeFilterPayload(globalFiltersRef.current, filters || []);
                  const updatedPaginations = {
                    ...paginationsRef.current,
                    'Employee Efforts': {
                      ...paginationsRef.current['Employee Efforts'],
                      page: 1,
                    },
                  };
                  setPaginations(updatedPaginations);
                  handleGlobalFilterApply(mergedFilters, globalSortRef.current, updatedPaginations);
                },
              },
            },
            apiEndpoints: {
              getAllViews: { endpoint: '', enabled: true },
              getFilteredData: { endpoint: '', enabled: false },
              saveOrUpdateView: { endpoint: 'view', enabled: true },
              deleteView: { endpoint: 'view-delete', enabled: false },
              download: {
                endpoint: '/export',
                enabled: true,
                filename: () => getEmployeeEffortsExportName(Summary),
                sheetName: () => getEmployeeEffortsExportName(Summary),
                transformResponse: Summary
                  ? undefined
                  : (payload) => transformEmployeeEffortsExport(payload || renderTableData),
              },
            },

            tableSettings: {
              enableTreeTable: false,
              size: 'small',
              loaderSkeleton: {
                rows: 10,
                bodyCells: 1,
                columns: Math.max(apiTableConfig.length || 1, 1),
              },
              pageSize: apiLimit,
              showPageSizeSelector: false,
              showPagination: false,
              paginationConfig: {
                page: apiPage,
                limit: apiLimit,
                total: apiTotal,
                onPaginationChange: (newPagination) => handlePaginationChange(tbl.toolBarHeading, newPagination),
                rowsPerPageOptions: [10, 15, 25, 50],
              },
              showExpandCollapse: false,
              tableConfig: apiTableConfig, // Use the updated config with the tooltip and restored filters
              maxFrozenColumns: { desktop: 4, tablet: 2, mobile: 1 },
              tableClassName,
            },
          },
          data: tableRows,
          toolBarHeading: tbl.toolBarHeading,
          useCustomBodyRenderer: tbl.useCustomBodyRenderer ?? false,
        };
        results.push(tableResult);

      }

      setTables(results);
      setGlobalFilterColumns(nextGlobalFilterColumns);
      setPaginations(updatedTotals);
      setIsTableRenderPending(true);
      setLoading(false);
      return true;
    } catch (err) {
      toast.error(err.message || 'An error occurred. Please try again.', {
        position: 'top-center',
        style: {
          backgroundColor: '#bc4545',
          color: '#FFFFFF',
          borderRadius: '12px',
          fontFamily: 'Mukta',
        },
      });
      setIsTableRenderPending(false);
      setLoading(false);
      return false;
    }
  };

  const handleGlobalSortApply = async (field, order, direction) => {
    const newSort = { field: normalizeHeaderField(field), order, direction };
    const applied = await handleGlobalFilterApply(globalFiltersRef.current, newSort, paginationsRef.current);
    if (applied) {
      setGlobalSort(newSort);
    }
  };

  const detailedGlobalFilters = globalFilterColumns.length > 0 ? globalFilterColumns : (
    tables.find((tbl) => tbl.toolBarHeading === 'Employee Efforts')
      ?.configuration?.tableSettings?.tableConfig || []
  ).filter((col) => col.isGlobalFilter);
  const summaryGlobalFilters = (
    tables.find((tbl) => tbl.toolBarHeading === 'Summary')
      ?.configuration?.tableSettings?.tableConfig || []
  ).filter((col) => col.isGlobalFilter);
  const allGlobalFilterColumns = [
    ...detailedGlobalFilters,
    ...summaryGlobalFilters,
  ].filter(
    (col, _idx, arr) =>
      arr.findIndex((value) => value.field === col.field) === arr.indexOf(col),
  );

  const allTablesEmpty = tables.every(tbl => !tbl.data || tbl.data.length === 0);
  const showTableSkeleton = loading || isTableRenderPending;
  const globalFilterUtilityConfiguration = allGlobalFilterColumns.length > 0 ? {
    generalSettings: {
      enableApiFiltering: false,
      showToolBar: true,
      toolBarSettings: {
        showToolBarHeading: false,
        showColumnFilterMenu: true,
        showFilterOption: true,
        showDownloadCsv: false,
        showDownloadExcel: false,
        showSearch: false,
        showSaveView: false,
      },
      headers: {
        token: userProfile?.access_token || localStorage.getItem('authToken') || '',
      },
      userInfo: {
        emailId: userProfile?.email,
        permissions: userProfile?.permissions,
        roleDetails: userProfile?.roleDetails,
        employeeId: userProfile?.employeeId,
        globalColors: userProfile?.siteConfiguration?.global_colors,
      },
      handler: {
        setTableStateHandler: (getState) => {
          globalFilterStateRef.current = getState;
        },
        onFilterUpdate: ({ action, filters }) => {
          if (action === 'reset') {
            const defaultFilters = buildDefaultDateRangeFilter();
            setGlobalFilters(defaultFilters);
            setGlobalSort(null);
            setPaginations(INITIAL_PAGINATIONS);
            setGlobalFilterColumns((previousColumns) => clearFilterColumnState(previousColumns));
            setTableResetKey((previousKey) => previousKey + 1);
            handleGlobalFilterApply(defaultFilters, null, INITIAL_PAGINATIONS);
            return;
          }
          if (action === 'apply') {
            handleGlobalFilterApply(filters || [], globalSortRef.current, paginationsRef.current);
          }
        },
      },
    },
    apiEndpoints: {
      getAllViews: { endpoint: '', enabled: false },
      getFilteredData: { endpoint: '', enabled: false },
      saveOrUpdateView: { endpoint: '', enabled: false },
      deleteView: { endpoint: '', enabled: false },
      download: { endpoint: '', enabled: false },
    },
    tableSettings: {
      enableTreeTable: false,
      size: 'small',
      pageSize: 1,
      showPageSizeSelector: false,
      paginationConfig: {
        page: 1,
        limit: 1,
        total: 0,
      },
      showExpandCollapse: false,
      tableConfig: allGlobalFilterColumns,
      tableClassName: 'edr-global-filter-hidden-table',
    },
  } : null;

  return (
    <div className={`filter-class${showTableSkeleton ? ' edr-effort-loading' : ''}`}>
      <Tooltip target=".exemption-tooltip" />

      <div className="edr-page-header">
        <h2>EDR Employee Effort</h2>
        {globalFilterUtilityConfiguration && (
          <div className="edr-global-filter-trigger">
            <TableUtility
              configuration={globalFilterUtilityConfiguration}
              data={[]}
              showFilterOption
              showTieredMenu
            />
          </div>
        )}
      </div>

      {showTableSkeleton && (
        <LocalSkeleton />
      )}

      <div style={{ display: showTableSkeleton ? 'none' : undefined }}>
        <TableUtility
          key={tableResetKey}
          tables={tables.map((tbl) => {
            const config = { ...tbl.configuration };
            if (config.tableSettings && config.tableSettings.paginationConfig) {
              config.tableSettings = {
                ...config.tableSettings,
                paginationConfig: {
                  ...config.tableSettings.paginationConfig,
                  onPaginationChange: loading
                    ? () => {}
                    : config.tableSettings.paginationConfig.onPaginationChange,
                },
              };
            }

            return {
              configuration: config,
              data: loading ? [] : tbl.data,
              useCustomBodyRenderer: typeof tbl.useCustomBodyRenderer === 'boolean' ? tbl.useCustomBodyRenderer : false,
            };
          })}
          showTieredMenu
          showDownloadCSV={false}
          loading={showTableSkeleton}
          onGlobalSortApply={handleGlobalSortApply}
          externalFilters={globalFilters}
          emptyStateComponent={!showTableSkeleton && allTablesEmpty ? <EdrEffortInitial /> : undefined}
          globalFilterAlignRight
        />
      </div>
    </div>
  );
};

export default EDREmployeeEffortMain;
